import React, { Component } from "react";
import withErrorCatcher from "../../components/Common/withErrorCatcher.js";
import { compose } from "recompose";
import { connect } from "react-redux";
import {
  withStyles,
  ListItemSecondaryAction,
  Button,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { updateUserProfile } from "../../../actions/userAction";
import moment from "moment";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond/dist/filepond.min.css";
import AdminSettingsTitle from "../admin/Common/AdminSettingsTitle.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

import { FilePond, registerPlugin } from "react-filepond";
import { withTranslation } from "react-i18next";
import FilePondPluginFileRename from "filepond-plugin-file-rename";
import { createCustomTheme, themeOptions } from "../../../utils/theming.js";
import { initSubscriptionModal, openSubscriptionModal } from "../../../actions/upgradeSubscriptionActions.js";
import { OldPagesWrap } from "../admin/newway/OldPagesWrap.js";

registerPlugin(FilePondPluginImagePreview);
registerPlugin(FilePondPluginFileRename);

// Apply some reset
const styles = (theme) => ({
  content: {
},
  paper: {
    padding: 16,
  },
  paperStyle: {
    marginBottom: 40,
  },
  listStyle: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  switchStyle: {
    marginBottom: 16,
  },
  submitStyle: {
    marginTop: 32,
  },
  userTitle: {
    fontSize: "18px",
    fontWeight: "100",
  },
  useSettingsTitle: {
    fontSize: "36px",
    fontWeight: "100",
  },
  textFiledStyle: {
    fontWeight: "100",
  },
  avatar: {
    width: 80,
    height: 80,
    border: "1px solid #dbdbdb",
  },
  row: {
    display: "flex",
    justifyContent: "center",
  },
  listLabel: {
    marginBottom: 10,
  },
  button: {
    margin: theme.spacing.unit,
  },
  uploadImage: {
    margin: 12,
    height: 100,
  },
  selectThemeHolder: {
    margin: 12,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  itemInfo: {
    width: "20%",
    marginRight: 20,
  },
  formControl: {
    position: 'relative',
    width: "30%",
    boxSizing: "border-box",
  },
  inputLabel: {
    fontSize: 18,
    color: theme.customColors.primary.b600,
    fontWeight: 600,
  },
  select: {
    color: theme.customColors.primary.main,
  },
  option: {
    color: theme.customColors.primary.main,
  },
  upgradeText: {
    position: 'absolute',
    left: -105,
    top: 5,
    cursor: 'pointer',
    textTransform: "uppercase",
    fontFamily: "Rubik",
    fontSize: 16,
    fontWeight: "500",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.5,
    letterSpacing: "normal",
    textAlign: "center",
    color: '#8645f9'
},
});

const downloadFile = async (myData) => {
  //const { myData } = this.state; // I am assuming that "this.state.myData"
  // is an object and I wrote it to file as
  // json
  const fileName = "template";
  const json = JSON.stringify(myData);
  const blob = new Blob([json], { type: "application/json" });
  const href = await URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName + ".json";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

class UserSettings extends Component {
  state = {
    personalFeedSwitchDisable: false,
    selectedTheme: "Default",
  };

  componentDidMount() {
    const { t } = this.props;
    const { brandingColor } = this.props.userData.profileData.org;
    this.setState({ selectedTheme: this.canChangeTheme() ? brandingColor : t('default') });
  }

  personalizedFeedChange = () => {
    const { dispatch, userSettingsService, userData } = this.props;
    const { isFeedPersonalized } = userData.profileData;

    this.setState({ personalFeedSwitchDisable: true });
    userSettingsService
      .updatePersonalizedFeed(!isFeedPersonalized)
      .then((res) => {
        dispatch({
          type: "USER_PROFILE_UPDATE",
          profileData: {
            isFeedPersonalized: !isFeedPersonalized,
          },
        });
        this.setState({ personalFeedSwitchDisable: false });
      });
  };

  onLoadImg = (res) => {
    const file = JSON.parse(res);
    // this.setState({ profileImageUrl: file.link });
    const { adminService } = this.props;

    adminService.updateOrganizationLogo(file.link).then((response) => {
      window.location.reload();
    });
  };

  uploadImg() {
    return (
      <FilePond
        allowMultiple="false"
        className={this.props.classes.uploadImage}
        allowDrop={false}
        acceptedFileTypes={["image/*"]}
        labelIdle={this.props.t("filesUploader:BrowseLogo")}
        fileRenameFunction={(file) => `logo${file.extension}`}
        server={{
          url: process.env.API_SERVER + "/files/s3",
          revert: null,
          restore: null,
          load: null,
          fetch: null,
          process: {
            headers: {
              Authorization: "Bearer " + this.props.userData.idToken,
            },
            onload: this.onLoadImg,
          },
        }}
      />
    );
  }

  generateTemplate = () => {
    const { adminService } = this.props;

    adminService.generateTemplate().then((response) => {
      downloadFile(response);
    });
  };

  applyPatch = (uid) => {
    const { adminService } = this.props;

    adminService.applyPatch(uid).then(() => {
      
    });
  };

  openSubscriptionDialog = () => {
    const { dispatch } = this.props;
    dispatch(initSubscriptionModal({reason: 'brandingColors', mode: 'existed'}))
    dispatch(openSubscriptionModal())
}

  handleSelectChange = (event) => {
    const { adminService, dispatch, userData } = this.props;
    if(!this.canChangeTheme()) return;
    adminService
      .updateOrganizationBrandColor(event.target.value)
      .then((response) => {
        this.setState({ selectedTheme: event.target.value });
        const updatedProfileData = Object.assign({}, userData.profileData);
        updatedProfileData.org.brandingColor =  event.target.value;
        dispatch(updateUserProfile(userData.profileData));
      });
  };

  // applyTemplate = () => {
  //     const { adminService } = this.props;

  //     adminService.applyTemplate(companyx2Template).then((response) => {

  //     })

  // }
  colorOptionStyle = (themeOption) => {
     const theme = createCustomTheme(themeOption)
     return {color: theme.primary.main}
  }

  canChangeTheme = () => {
    const {subscriptionType} = this.props;
    return !([0, 1].includes(subscriptionType))
  }

  renderUpgradePlan = () => {
    const { classes,t } = this.props;
    
    return (
          <div data-intrcm-id="organizationSettings_f10xbuoe" onClick={this.openSubscriptionDialog} className={classes.upgradeText}>{t('Upgrade')}</div>
    )
}

  render() {
    const { userData, classes,t } = this.props;
    const { address, creationDateTime, lastModification, orgUid, title } =
      userData.profileData.org;
    const allowChangeTheme = this.canChangeTheme()
    return (
      <OldPagesWrap classNameContent={classes.content} >
              <AdminSettingsTitle text={t("Organization settings")} />
              <Paper className={classes.paperStyle}>
                <List className={classes.listStyle}>
                  <ListItem>
                    <ListItemText
                      primary={title}
                      secondary={t("Organization Name")}
                    />
                    <ListItemSecondaryAction>
                      <Button onClick={this.generateTemplate}>
                        {t('Generate Template')}
                      </Button>

                      {/* <Button onClick={()=>{this.applyPatch("newReportView")}}>
                        {t('Apply patch 7.3.0')}
                      </Button>
                      <Button onClick={()=>{this.applyPatch("fixStatus")}}>
                        {t('Fix status')}
                      </Button>
                      <Button onClick={()=>{this.applyPatch("fixTableView")}}>
                        {t('Apply fix 7.3.0')}
                      </Button>
                      <Button onClick={()=>{this.applyPatch("fixCounter")}}>
                        {t('fix counter')}
                      </Button> */}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />

                  <ListItem>
                    <ListItemText primary={address} secondary={t("Address")} />
                    {/* <ListItemSecondaryAction>
                                        <Button onClick={this.applyTemplate} >
                                            Apply Template
                                        </Button>
                                    </ListItemSecondaryAction> */}
                  </ListItem>

                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary={orgUid}
                      secondary={t("Organization UID ")}
                    />
                  </ListItem>
                  <Divider />
                  {/* <ListItem>
                                        <ListItemText
                                            primary={description}
                                            secondary='Org Description' />
                                    </ListItem> */}
                  <ListItem>
                    <ListItemText
                      primary={moment(lastModification).format(
                        "MMMM Do YYYY, H:mm"
                      )}
                      secondary={t("Last Update")}
                    />
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <ListItemText
                      primary={moment(creationDateTime).format(
                        "MMMM Do YYYY, H:mm"
                      )}
                      secondary={t("Created on")}
                    />
                  </ListItem>
                  <Divider />
                  <div data-intrcm-id="organizationSettings_ab52x28x" className={classes.selectThemeHolder}>
                    <div data-intrcm-id="organizationSettings_j4t1zdwp" className={classes.itemInfo}>
                      <ListItemText
                        primary={t(this.state.selectedTheme)}
                        secondary={t("Select theme")}
                      />
                    </div>
                    <FormControl className={classes.formControl}>
                      {!this.canChangeTheme() && this.renderUpgradePlan()}
                      <Select
                        disabled={!allowChangeTheme}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={t(this.state.selectedTheme)}
                        onChange={this.handleSelectChange}
                        className={classes.select}
                      >
                        {themeOptions.map(({option, placeholder}, i) => (
                          <MenuItem key={`theme-${i}`} value={option} style={this.colorOptionStyle(option)} className={classes.option}>
                            {placeholder}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <Divider />
                  {this.uploadImg()}
                  <Divider />
                </List>
              </Paper>
            </OldPagesWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.userData,
  subscriptionType: state.globalData.currentSubscription.subscriptionType,
  ...state.services,
});

const mapDispatchToProps = (dispatch) => {
  return { dispatch: dispatch };
};

export default compose(
  withStyles(styles),
  withErrorCatcher(
    "Failed Loading Organization Settings, Please Contact Tuqqi Support"
  ),
  withTranslation("admin"),
  connect(mapStateToProps, mapDispatchToProps)
)(UserSettings);